export class UserNotLoggedInError extends Error {
}
